export default class AutoHideOverflow extends HTMLDivElement {
    constructor() {
        super();
        this.updateVisibleItems = this.updateVisibleItems.bind(this);
        this.resizeObserver = new ResizeObserver(this.updateVisibleItems);
        this.marginWidth = 8;
    }

    connectedCallback() {
        const itemMargin = this.getAttribute('item-margin');
        if (itemMargin !== null) {
            this.marginWidth = parseInt(itemMargin, 10);
        }

        this.resizeObserver.observe(this);
        window.addEventListener('resize', this.updateVisibleItems);
        this.updateVisibleItems();
    }

    disconnectedCallback() {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.updateVisibleItems);
    }

    updateVisibleItems() {
        const containerWidth = this.clientWidth;
        const children = Array.from(this.children);
        let totalWidth = 0;

        children.forEach((child) => {
            child.style.removeProperty('display');
        });

        void this.offsetHeight;

        children.forEach((child, index) => {
            const childWidth = child.offsetWidth;
            const widthWithMargin = index === 0 ? childWidth : childWidth + this.marginWidth;

            if (totalWidth + widthWithMargin <= containerWidth) {
                child.style.removeProperty('display');
                totalWidth += widthWithMargin;
            } else {
                child.style.display = 'none';
            }
        });
    }
}